import type { IconData } from '../../types';

export const data: IconData = {
  o: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M4 4v16M8 8v12M12 6v14M16 6l4 14"/></g>',
  f: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M4 4v16M8 8v12M12 6v14M16 6l4 14"/></g>',
  vb: '0 0 24 24',
};

export default data;
